var $ = require("jquery");
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

/* ====================== GALLERY SLIDER ======================  */
document.querySelectorAll('.gallery__slider').forEach((grid) => {
  const $nextButton = grid.querySelector('.swiper-button-next');
  const $prevButton = grid.querySelector('.swiper-button-prev');
  const $pagination = grid.querySelector('.swiper-pagination');

  const swiper = new Swiper(grid.querySelector('.swiper'), {
    speed: 1000,
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 12,
    allowTouchMove: true,
    pagination: {
      el: $pagination,
      clickable: true,
    },
    navigation: {
      nextEl: $nextButton || null,
      prevEl: $prevButton || null,
    },
    breakpoints: {
      1025: {
        slidesPerView: 'auto',
      },
    }
  })
});



/* ====================== QUOTE SLIDER ======================  */
document.querySelectorAll('.quote__slider').forEach((grid) => {
  // const $progressBar = grid.querySelector('.swiper-pagination');
  const $nextButton = grid.querySelector('.swiper-button-next');
  const $prevButton = grid.querySelector('.swiper-button-prev');
  const $progressBar = grid.querySelector('.swiper-pagination');

  const swiper = new Swiper(grid.querySelector('.swiper'), {
    speed: 1000,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 90,
    centeredSlides: true,
    navigation: {
      nextEl: $nextButton || null,
      prevEl: $prevButton || null,
    },
    pagination: {
        el: $progressBar || null,
        type: "progressbar",
    },
  });
});
